import { useState } from 'react';
import dayjs from 'dayjs';
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg?react';
const SmsHistoryItem = ({ sms, onViewDetail }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const truncateMessage = (message, maxLength = 50) => {
    if (!message) return '-';
    return message.length > maxLength ? `${message.substring(0, maxLength)}...` : message;
  };

  return (
    <>
      <tr>
        <td onClick={() => setIsExpanded(!isExpanded)} className="cursor-pointer">{isExpanded ? <ChevronDownIcon style={{ transform: 'rotate(-180deg)', transition: 'transform 0.2s ease' }} /> : <ChevronDownIcon style={{ transition: 'transform 0.2s ease' }} />}</td>
        <td className="sms-date">
          {sms?.RequestedAt ? dayjs(sms.RequestedAt).format('YYYY-MM-DD HH:mm:ss') : '-'}
        </td>
        <td className="sms-total-count">{sms?.TotalCount || 0}</td>
        <td className="sms-success-count">{sms?.SuccessCount || 0}</td>
        <td className="sms-fail-count">{sms?.FailCount || 0}</td>
      </tr>
      {
        isExpanded && (
          <tr>
            <td colSpan="5">
              <div className="sms-message flex flex-col gap-5">
                <p className='text-b2-700 text-gray-400'>메시지</p>
                <pre className='text-c1-400 text-gray-700 whitespace-pre-wrap'>
                  {sms?.Message}
                </pre>
              </div>
            </td>
          </tr>
        )
      }
    </>
  );
};

export default SmsHistoryItem;
